/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerEnquiry as ModelsCustomerCustomerEnquiry } from '../../models/Models/Customer/customer-enquiry';

export interface V3CustomersMeEnquiryPost$Xml$Plain$Params {
      body?: ModelsCustomerCustomerEnquiry
}

export function v3CustomersMeEnquiryPost$Xml$Plain(http: HttpClient, rootUrl: string, params?: V3CustomersMeEnquiryPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeEnquiryPost$Xml$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerEnquiry>;
    })
  );
}

v3CustomersMeEnquiryPost$Xml$Plain.PATH = '/v3/customers/me/enquiry';
